/**
 * Alert <uo-placeholder>
 */

// Import style
import './style.scss';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { isDefined } from '@automator/utilities';

// Import style for web component
const styles = require( './web-component-style.scss' );

// eslint-disable-next-line require-jsdoc
@customElement( 'uo-placeholder' )
export class AutomatorPlaceholder extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property({ type: String }) width;
	@property({ type: String }) height;

	// eslint-disable-next-line require-jsdoc
	constructor() {
		super();
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div 
				class="placeholder"
				style="
					${ isDefined( this.width ) ? `width: ${ this.width };` : '' }
					${ isDefined( this.height ) ? `height: ${ this.height };` : '' }
				"
			></div>
		`;
	}
}